import Tab from "@material-ui/core/Tab";
import { withStyles } from "@material-ui/core";
import { tesaWhite, tesaWhiteHighlight, tesaWhiteHighlight2 } from "../../styles/colors";

export const StyledVerticalTab = withStyles((theme) => ({
  root: {
    borderBottomWidth: `0px !important`,
    borderTopWidth: `0px !important`,
    color: `${tesaWhite} !important`,

    "&:last-child": {
      marginBottom: 0,
    },
    "&.minimized": {
      marginBottom: 0,
      // must override theme
      maxWidth: "100%",
      minHeight: "56px",
      minWidth: "0 !important",
      width: "60px",

      "& .MuiTab-wrapper": {
        paddingLeft: 0,
        justifyContent: "center",
      },
    },
  },
  labelIcon: {
    minHeight: "56px",
    paddingTop: 0,
    "& .MuiTab-wrapper > *:first-child": {
      marginBottom: 0,
      minHeight: "56px",
      paddingTop: 0,
    },
  },
  selected: {
    backgroundColor: tesaWhiteHighlight,
    color: `${tesaWhite} !important`,
  },
  textColorInherit: {
    opacity: 1,
  },
  wrapper: {
    flexDirection: "row",
    paddingLeft: theme.spacing(3),
    justifyContent: "flex-start",
    "& > *:nth-child(2)": {
      paddingLeft: theme.spacing(1.5),
    },
  },
}))(Tab);

export const StyledVerticalSubTab = withStyles((theme) => ({
  root: {
    backgroundColor: tesaWhiteHighlight,
    borderBottomWidth: `0px !important`,
    borderTopWidth: `0px !important`,
    color: `${tesaWhite} !important`,
    fontFamily: "Proxima Nova",
    marginBottom: theme.spacing(0),
    textTransform: "none",
    minHeight: theme.spacing(4),

    "&.minimized": {
      marginBottom: 0,
      // must override theme
      maxWidth: "100%",
      minHeight: "56px",
      minWidth: "0 !important",
      width: "60px",

      "& .MuiTab-wrapper": {
        alignItems: "center",
        fontSize: "0.875rem",
        fontWeight: 700,
        paddingLeft: 0,
      },
    },
  },
  selected: {
    color: `${tesaWhite} !important`,
    backgroundColor: tesaWhiteHighlight2,
  },
  textColorInherit: {
    opacity: 1,
  },
  wrapper: {
    alignItems: "flex-start",
    paddingLeft: "60px",
  },
}))(Tab);
